export default __webpack_public_path__ + "static/media/8.99faf7b2.jpg";